/**
 * Animated "Search ..." placeholder for the style4 header search pill.
 *
 * Attach `data-dtf-typewriter` to either:
 *   - an <input>  -> the `placeholder` attribute is animated
 *   - any element -> its textContent is animated (used by the compact
 *                    mobile pill, where the real input is visually hidden)
 *
 * Optional attributes:
 *   data-dtf-typewriter-terms  "gang sheet|UV sticker|hoodie"
 *   data-dtf-typewriter-prefix "Search "   (default)
 *   data-dtf-typewriter-suffix "..."       (default)
 */
(function () {
  var DEFAULT_TERMS = [
    'gang sheets',
    'UV stickers',
    'glitter transfers',
    't-shirts',
    'hoodies',
    'sample packs',
    'heat tape',
  ];

  var TYPE_MS = 60;
  var DELETE_MS = 30;
  var HOLD_MS = 1500;
  var BETWEEN_MS = 350;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function parseTerms(el) {
    var raw = el.getAttribute('data-dtf-typewriter-terms');
    if (!raw) return DEFAULT_TERMS.slice();
    var list = raw
      .split('|')
      .map(function (term) {
        return term.trim();
      })
      .filter(Boolean);
    return list.length ? list : DEFAULT_TERMS.slice();
  }

  function start(el) {
    var isInput = el.tagName === 'INPUT';
    var terms = parseTerms(el);
    var prefix = el.getAttribute('data-dtf-typewriter-prefix');
    var suffix = el.getAttribute('data-dtf-typewriter-suffix');
    if (prefix === null) prefix = 'Search ';
    if (suffix === null) suffix = '...';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var index = 0;
    var timer = null;
    var paused = false;

    function write(text) {
      if (isInput) el.setAttribute('placeholder', text);
      else el.textContent = text;
    }

    function staticPlaceholder() {
      write(prefix.trim() + suffix);
    }

    function clear() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    }

    function schedule(fn, delay) {
      clear();
      timer = setTimeout(fn, delay);
    }

    // The input already has user input or focus: never fight the user for
    // the placeholder, and never animate a field they are reading.
    function shouldRun() {
      if (paused || reduceMotion.matches) return false;
      if (document.hidden) return false;
      if (isInput && (el.value || document.activeElement === el)) return false;
      return true;
    }

    function typeIn(term, position) {
      if (!shouldRun()) return stop();
      el.classList.add('dtf-typewriter--typing');
      write(prefix + term.slice(0, position) + suffix);
      if (position < term.length) {
        schedule(function () {
          typeIn(term, position + 1);
        }, TYPE_MS);
        return;
      }
      el.classList.remove('dtf-typewriter--typing');
      schedule(function () {
        deleteOut(term, term.length);
      }, HOLD_MS);
    }

    function deleteOut(term, position) {
      if (!shouldRun()) return stop();
      el.classList.add('dtf-typewriter--typing');
      write(prefix + term.slice(0, position) + suffix);
      if (position > 0) {
        schedule(function () {
          deleteOut(term, position - 1);
        }, DELETE_MS);
        return;
      }
      index = (index + 1) % terms.length;
      schedule(next, BETWEEN_MS);
    }

    function next() {
      if (!shouldRun()) return stop();
      typeIn(terms[index], 0);
    }

    function stop() {
      clear();
      el.classList.remove('dtf-typewriter--typing');
      staticPlaceholder();
    }

    function restart() {
      if (!shouldRun()) return stop();
      schedule(next, BETWEEN_MS);
    }

    if (isInput) {
      el.addEventListener('focus', function () {
        paused = true;
        stop();
      });
      el.addEventListener('blur', function () {
        paused = false;
        restart();
      });
      el.addEventListener('input', function () {
        if (el.value) stop();
      });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clear();
      else restart();
    });

    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', restart);
    }

    restart();
  }

  ready(function () {
    var targets = document.querySelectorAll('[data-dtf-typewriter]');
    for (var i = 0; i < targets.length; i++) start(targets[i]);
  });
})();
